import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { Switch } from "react-router";
import queryString from "query-string";
import { EventRoute, StyledFooter } from "@minerva-analytics/pantheon";

import routes from "../../routes";
import { GOOGLE_ANALYTICS_TAG, SITE_URL } from "../../constants";
import { GlobalStyle } from "../../index.styles";
import { PageContainer } from "./App.styles";
import { starterTheme, WHITE } from "../../theme";
import Nav from "../../components/Nav/Nav";
import * as referralActions from "../../store/referral/actions";

import { saveCampaignParamsRedux } from "../../store/session/actions";

const App = () => {
  const [isInitialPageView, setIsInitialPageView] = useState(true);
  const { search, pathname, hash } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const parsed = queryString.parse(search);

    dispatch(saveCampaignParamsRedux(parsed));
  }, []);

  useEffect(() => {
    if (hash.includes(`#ref=`)) {
      const referralId = Number(hash.match(/\d+/)[0]);
      dispatch(referralActions.getReferralId(referralId));
    }
  }, [hash]);

  return (
    <>
      <Helmet>
        <html lang="en" />
        <link
          rel="shortcut icon"
          type="image/ico"
          href="https://storage.googleapis.com/cookingandcocktails-assets/favicon.png"
        />
        <link rel="preconnect" href="https://connect.facebook.net/" />
        <link rel="preconnect" href="https://facebook.com" />
        <link
          rel="canonical"
          href={`https://www.cookingncocktails.com${pathname}`}
        />
        <title>{`Daily International Recipe Newsletter | Cooking & Cocktails`}</title>
        <meta
          name="og:title"
          property="og:title"
          content="Daily International Recipe Newsletter | Cooking & Cocktails"
        />
        <meta
          name="og:description"
          property="og:description"
          content="Want to get a new international recipe delivered to your inbox every day? Sign up for our newsletter!"
        />
        <meta
          name="description"
          property="description"
          content="Want to get a new international recipe delivered to your inbox every day? Sign up for our newsletter!"
        />
        <meta
          name="keywords"
          property="keywords"
          content="cooking, cocktails, recipes"
        />
        <meta name="og:type" property="og:type" content="website" />
        <meta
          name="og:url"
          property="og:url"
          content="https://www.cookingncocktails.com"
        />
        <meta
          name="og:site_name"
          property="og:site_name"
          content="Cooking and Cocktails"
        />
        <meta
          name="og:image"
          property="og:image"
          content="https://storage.googleapis.com/cookingandcocktails-assets/favicon.png"
        />
      </Helmet>
      <ThemeProvider theme={starterTheme}>
        <GlobalStyle />
        <Nav />
        <PageContainer>
          <Switch>
            {routes.map((r) => (
              <EventRoute
                {...r}
                onPageChange={[
                  () => {
                    if (!isInitialPageView && window.gtag) {
                      window.gtag(`config`, GOOGLE_ANALYTICS_TAG, {
                        page_title: document.title,
                        page_path: pathname + search,
                      });
                    } else {
                      setIsInitialPageView(false);
                    }
                  },
                ]}
              />
            ))}
          </Switch>
        </PageContainer>
        <StyledFooter
          productName="Cooking & Cocktails"
          productLogo="https://storage.googleapis.com/cookingandcocktails-assets/favicon.png"
          textColor={WHITE}
          socialButtons={{
            facebook:
              "https://www.facebook.com/Cooking-Cocktails-102680178530069/",
          }}
          links={[
            {
              to: `${SITE_URL}/contact`,
              title: "Contact Us",
              useFullInternalLink: true,
            },
            {
              to: `${SITE_URL}/privacy`,
              title: "Privacy Policy",
              useFullInternalLink: true,
            },
            {
              to: `${SITE_URL}/terms`,
              title: "Terms of Use",
              useFullInternalLink: true,
            },
            {
              to: `${SITE_URL}/cookie`,
              title: "Cookie Policy",
              useFullInternalLink: true,
            },
            {
              to: `${SITE_URL}/ccpa`,
              title: "CA Privacy Policy",
              useFullInternalLink: true,
            },
          ]}
        />
      </ThemeProvider>
    </>
  );
};

export default App;
